import React, { useRef, useState, useEffect } from "react";
import enUS from "../../../data/en-US";
import { useLanguageContext } from "../../../context/languageContext";
import { useThemeContext } from "../../../context/themeContext";
import { fakedb } from "../../../data/fakedb";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import Card02 from "../../cards/Card02";
import Card03 from "../../cards/Card03";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Button from "../../buttons/Button";
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from "react-redux";
import { getUserById } from "actions/contributor/homeActions";

const PremiumSection = () => {
    const dispatch = useDispatch();
    // Pull the languange proivder and pull the theme setting provider and pull the content
    const { language } = useLanguageContext();
    const { themeSetting } = useThemeContext();
    const [ data, setData ] = useState();
    const info = {
        'en-US': enUS
    }

    const gradStyle = {
        background: `linear-gradient(to right, ${themeSetting.colors.primary}, ${themeSetting.colors.secondary}, 70%)`
    }

    useEffect(() => {
        setData(info[language].homepage.premium_users)
    })

    // pull the user info from cookie
    const userCookie = Cookies.getJSON('userInfo') || null;
    
    // get the logged in user by id
    const signedinUser = useSelector(state => state.signedinUser.userInfo)
    useEffect(() => {
        if (userCookie) {
            dispatch(getUserById(userCookie.id))
        }    
    }, [])
    
    //check if the role of the logged in user is contributor
    const [ isPremium, setIsPremium ] = useState(false)
    const premiumRoleArr = [9, 10]
    useEffect(() => {
        signedinUser && 
            premiumRoleArr.filter(p => p === signedinUser.role_id).length > 0 ? setIsPremium(true) : setIsPremium(false)
    }, [signedinUser])

    return (
        <div className="themesflat-container font-face-poppins premium-section-wrapper text-center">
            <div className="premium-heading-wrapper font-face-pop" style={gradStyle}>
                <h1 className={`bg-gradient-to-r from-[#0C98CC] to-[#F9BE10] inline-block text-transparent bg-clip-text`}>
                    { data && data.heading }
                </h1>
            </div>
            <div className="premium-heading-below">
                { data && data.heading_below }
            </div>
            <div className="premium-luncmeet-section text-center">
                <div className="premium-luncmeet-section-heading font-face-pop">
                    { data && data.body.luncmeet.heading }
                </div>
                <div className="premium-luncmeet-section-body row">
                    <div className="col-md-1"></div>
                    <div className="col-md-10">
                        { data && data.body.luncmeet.body }
                    </div>
                    <div className="col-md-1"></div>
                </div>
                <div className="premium-luncmeet-section-show">
                    <div className="premium-luncmeet-section-show-title font-face-pop text-center md:text-left mt-3">
                        { data && data.body.luncmeet.picture_description}
                    </div>
                    <Swiper
                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                        spaceBetween={30}

                        breakpoints={{
                            0: {
                                slidesPerView: 1,
                            },
                            767: {
                            slidesPerView: 2,
                            },
                            991: {
                            slidesPerView: 3,
                            },
                            1300: {
                                slidesPerView: 5,
                            },
                        }}
                        navigation
                        pagination={{ clickable: true }}
                        scrollbar={{ draggable: true }}
                    >
                            {
                                fakedb.luncmeets_top_5.slice(0,5).map((item,index) => (
                                    <SwiperSlide key={index}>
                                            <div className="swiper-container show-shadow carousel auctions">
                                                <div className="swiper-wrapper">
                                                    <div className="swiper-slide">
                                                        <div className="slider-item">										
                                                            <Card02 item={item} index={index}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                    </SwiperSlide>
                                ))
                            }
                    </Swiper>
                </div>
            </div>
            <div className="premium-marketplace-section text-center">
                <div className="premium-marketplace-section-heading font-face-pop">
                    { data && data.body.marketplace.heading }
                </div>
                <div className="premium-marketplace-section-body row">
                    <div className="col-md-1"></div>
                    <div className="col-md-10">
                        { data && data.body.marketplace.body }
                    </div>
                    <div className="col-md-1"></div>
                </div>
                <div className="premium-marketplace-section-show">
                    <div className="premium-marketplace-section-show-title mt-3 font-face-pop text-center md:text-left">
                        { data && data.body.marketplace.picture_description }
                    </div>
                    <Swiper
                    modules={[Navigation, Pagination, Scrollbar, A11y]}
                    spaceBetween={30}

                    breakpoints={{
                        0: {
                            slidesPerView: 1,
                        },
                        767: {
                        slidesPerView: 2,
                        },
                        991: {
                        slidesPerView: 3,
                        },
                        1300: {
                            slidesPerView: 5,
                        },
                    }}
                    navigation
                    pagination={{ clickable: true }}
                    scrollbar={{ draggable: true }}
                >
                        {
                            fakedb.marketplace_top_5.slice(0,5).map((item,index) => (
                                <SwiperSlide key={index}>
                                        <div className="swiper-container show-shadow carousel auctions">
                                            <div className="swiper-wrapper">
                                                <div className="swiper-slide">
                                                    <div className="slider-item">										
                                                        <Card02 item={item} showStyle="penta" index={index}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                </SwiperSlide>
                            ))
                        }
                </Swiper>
                </div>
            </div>
            <div className="premium-freelance-gigs">
                <div className="premium-freelance-gigs-heading text-center font-face-pop">
                    { data && data.body.gigs.heading }
                </div>
                <div className="freelance-gigs-swiper-wrapper" style={{position:'relative'}}>
                    <Swiper
                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                        spaceBetween={30}
                        breakpoints={{
                            0: {
                                slidesPerView: 1,
                            },
                            767: {
                            slidesPerView: 2,
                            },
                            991: {
                            slidesPerView: 3,
                            }
                        }}
                        loop={true}
                        navigation={{
                            nextEl: '.review-swiper-button-next',
                            prevEl: '.review-swiper-button-prev',
                        }}
                        pagination={{ clickable: true }}
                        scrollbar={{ draggable: true }}
                    >
                            {
                                fakedb.freelance_top_5.slice(0,5).map((item,index) => (
                                    <SwiperSlide key={index}>
                                            <div className="swiper-container show-shadow carousel auctions">
                                                <div className="swiper-wrapper">
                                                    <div className="swiper-slide">
                                                        <div className="slider-item">										
                                                            <Card03 item={item} index={index}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                    </SwiperSlide>
                                ))
                            }
                    </Swiper>
                    <div className="review-swiper-button-next">
                        <FaAngleLeft/>
                    </div>
                    <div className="review-swiper-button-prev">
                        <FaAngleRight/>
                    </div>
                </div>
            </div>
            <div className="premium-footer text-center font-face-poppins">
                {
                    isPremium ? '' : 
                    <>
                        <div className="premium-footer-btn-description">
                            { data && data.footer.button_description }
                        </div>
                        <div className="premium-footer-btn">
                            <Button
                                width={326}
                                height={48}
                                text={data && data.footer.button}
                                borderRadius={5}
                                theme='gradient'
                                fontSize='1em'
                                lineHeight={'30px'}
                            />
                        </div>
                    </>
                }
            </div>
        </div>
    )
}

export default PremiumSection;